var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.84 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.1,3.85L13.57,5.39A0.77,0.77,0,1,1,12.48,4.3L14,2.77A0.77,0.77,0,1,1,15.1,3.85m-5.91.22a0.77,0.77,0,0,1-.77-0.77v-2a0.77,0.77,0,0,1,1.53,0v2a0.77,0.77,0,0,1-.77.77m-3.29,9L4.36,14.59a0.77,0.77,0,1,1-1.08-1.08L4.81,12A0.77,0.77,0,1,1,5.9,13.06M5.35,5.61a0.76,0.76,0,0,1-.54-0.22L3.28,3.85A0.77,0.77,0,1,1,4.36,2.77L5.9,4.3a0.77,0.77,0,0,1-.54,1.31M4.59,8.68a0.77,0.77,0,0,1-.77.77h-2a0.77,0.77,0,1,1,0-1.53h2a0.77,0.77,0,0,1,.77.77",
    style: {
      fillRule: "evenodd"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5481affb-e88a-4222-9462-ff9cdc22736a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95,15.53l-1.41-8a0.24,0.24,0,0,1,.28-0.28L15.9,8.6c0.18,0,.22.15,0.1,0.27l-2.4,2.05L16.73,14a0.34,0.34,0,0,1,0,.47l-1.95,1.91a0.34,0.34,0,0,1-.47,0L11.18,13.3l-2,2.33C9.09,15.75,9,15.7,8.95,15.53Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.2c023009970893503612da1be4aefdfa.svg";
export { ForwardRef as ReactComponent };